import { gql } from '@apollo/client'

const CREATE_CASH_CREDIT_DIFFERENTIAL_MUTATION = gql`
  mutation createCashCreditDifferentialMutation(
    $stationId: ID!
    $fuelGradeId: ID!
    $differential: Float!
  ) {
    createCashCreditDifferential(
      input: {
        stationId: $stationId
        fuelGradeId: $fuelGradeId
        differential: $differential
      }
    ) {
      error
      cashCreditDifferential {
        id
        fuelGradeId
        differential
      }
    }
  }
`

const CREATE_FUEL_GRADE_DIFFERENTIAL_MUTATION = gql`
  mutation createFuelGradeDifferentialMutation(
    $stationId: ID!
    $fuelGradeId: ID!
    $leadGradeId: ID!
    $differential: Float!
  ) {
    createFuelGradeDifferential(
      input: {
        stationId: $stationId
        fuelGradeId: $fuelGradeId
        leadGradeId: $leadGradeId
        differential: $differential
      }
    ) {
      error
      fuelGradeDifferential {
        id
        fuelGradeId
        leadGrade
        leadGradeId
        differential
      }
    }
  }
`

const ADD_STATION_COMPETITOR_MUTATION = gql`
  mutation addStationCompetitor($stationId: ID!, $competitorId: ID!) {
    addStationCompetitor(
      input: { stationId: $stationId, competitorId: $competitorId }
    ) {
      error
      competitor {
        id
        name
        brand {
          id
          name
          key
        }
        influencer
        cashCreditPricing
        distances {
          drivingDistanceKilometres
          drivingDistanceMiles
        }
      }
    }
  }
`

const REMOVE_STATION_COMPETITOR_MUTATION = gql`
  mutation removeStationCompetitor($stationId: ID!, $competitorId: ID!) {
    removeStationCompetitor(
      input: { stationId: $stationId, competitorId: $competitorId }
    ) {
      error
      success
    }
  }
`

const DELETE_CASH_CREDIT_DIFFERENTIAL_MUTATION = gql`
  mutation deleteCashCreditDifferentialMutation(
    $stationId: ID!
    $fuelGradeId: ID!
  ) {
    deleteCashCreditDifferential(
      input: { stationId: $stationId, fuelGradeId: $fuelGradeId }
    ) {
      error
      success
    }
  }
`

export {
  CREATE_CASH_CREDIT_DIFFERENTIAL_MUTATION,
  CREATE_FUEL_GRADE_DIFFERENTIAL_MUTATION,
  ADD_STATION_COMPETITOR_MUTATION,
  REMOVE_STATION_COMPETITOR_MUTATION,
  DELETE_CASH_CREDIT_DIFFERENTIAL_MUTATION,
}
